
import { SaleLayoutFreeLine } from "@/utils/sale-layouts/free-line";
import { SaleLayoutTotalLines } from "@/utils/sale-layouts/total-lines";
import Vue from "vue";
import { DocumentPageSettings } from "@/utils/documents/page-settings";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import AppPayments from "./Payments.vue";
import AppFreeLine from "./FreeLine.vue";

export default Vue.extend({
	props: {
		layout: {
			type: Object as ()=>SaleLayout,
			required: true
		},
		lang: String,
	},
	computed: {
		freeLines():SaleLayoutFreeLine[] {
			return this.layout.FreeLines;
		},
		totals():SaleLayoutTotalLines {
			return this.layout.TotalLines;
		},
		pageSettings():DocumentPageSettings {
			return this.layout.PageSettings;
		},
		cssVars(): any {
			return {
				"--bg-color": this.pageSettings.DefaultBackgroundColor,
				"--border-color": this.pageSettings.DefaultBorderColor,
				"--border-width": this.pageSettings.DefaultBorderSize + "px"
			};
		},
		beforeFreeLines(): SaleLayoutFreeLine[] {
			return this.freeLines.filter(f => f.Placement == "AfterDetail");
		},
		totalsFreeLines(): SaleLayoutFreeLine[] {
			return this.freeLines.filter(f => f.Placement == "Totals");
		},
		hasBeforeTotalFreeLines():boolean {
			return this.beforeFreeLines.length > 0;
		},
		trStyle():any {
			return {
				borderColor: this.pageSettings.DefaultBorderColor
			};
		},
		totalsStlye():any{
			if (this.layout.TotalLines.UseTotalLineStyleOverride){
				return this.layout.TotalLines.TotalLineStyleOverride.getStyle();
			}
			return this.trStyle;
		},
		toPayBeforeStyle():any{
			if (this.layout.TotalLines.UseGrandTotalLineStyleOverride){
				return this.layout.TotalLines.GrandTotalLineStyleOverride.getStyle();
			}
			return {
				...this.trStyle,
				background: this.pageSettings.DefaultBackgroundColor
			};
		}
	},
	components: {
		AppPayments,
		AppFreeLine
	}
});
